import './cookieBanner.css';

var styles = {"hidden":"hidden__JyCYu","cookieBanner":"cookieBanner__2Ja4P","textContainer":"textContainer__3VFKd","text":"text__1pWaU","buttonBox":"buttonBox__26NMI","button":"button__3Og72"};

export { styles as default };
